import { optionsToStrategy } from '@/common/utils/optionsToStrategy'

export const relationTypeOptions = [
  { label: 'Responsável', value: 'responsible' },
  { label: 'Acompanha', value: 'appendant' },
]

export const relationTypeStrategy = optionsToStrategy(relationTypeOptions)
